import React, {useRef, useState} from "react";
import "./UploadImageFile.scss"
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import {css} from "@emotion/css";
import {LinearProgress} from "@mui/material";
import {
    dataURLtoFile,
    RaikoAlert,
    raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import UploadThumbnail from "../../../component/uploadThumbnail/UploadThumbnail";
import MainImageCropper from "../../../component/raikoImageCropper/mainImageCropper/MainImageCropper";
import thumbnail from "../../../component/uploadThumbnail/img/Focus-cuate.svg";

export default function UploadImageFile(
    {
        uploadUrl,
        handleRefreshList
    }
) {

    const service = new FileManagerService()

    const [showUploadLoading, setShowUploadLoading] = useState(false)

    const [uploadPercent, setUploadPercent] = useState(0);

    const [photoFileName, setPhotoFileName] = useState("")






    function handleHideLoading() {
        setUploadPercent(0)
    }

    function handleUploadImage(photoFile) {
        setShowUploadLoading(true)

        service.uploadImageFile(
            photoFile,
            handleHideLoading,
            setUploadPercent,
            uploadUrl
        ).then(response => {
            showSuccessMessage("عکس جدید با موفقیت بارگزاری شد.")
            setPhotoFileName("")
            setPhotoFile(null)
            handleRefreshList(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setShowUploadLoading(false)
        })
    }

    const [photoFile, setPhotoFile] = useState(null)
    const [photoUrl, setPhotoUrl] = useState("");

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        // setPhotoUrl(imgSrc)
        // setPhotoFile(imageFile)
        // setPhotoFileName(fileName)
        handleUploadImage(imageFile)
    }


    return (
        <div className={"baseUploadImageFileContainer"}>

           {/* {
                imageFile ?
                    <RaikoGridOneColumn>
                        <img src={URL.createObjectURL(imageFile)} alt={photoFileName}
                             className={"selectedImagePreview"}/>
                    </RaikoGridOneColumn> :
                    <RaikoAlert
                        type={raikoAlertTypes.info}
                        title={"بارگزاری تصویر جدید"}
                        description={[
                            "* تنها فرمت قابل پذیرش jpeg و jpg می باشد.",
                            "",
                        ]}
                        className={css`width: 100%`}
                    />
            }*/}

            {/*<UploadThumbnail
                avatarFile={photoUrl}
                updateAvatar={handleSelectImage}
                loading={false}
            />*/}

            <MainImageCropper
                updateAvatar={handleSelectImage}
                ASPECT_RATIO={3/2}
                thumbnail={thumbnail}
                primaryButtonTitle={"برش و بارگزاری"}
                secondaryButtonTitle={"انتخاب مجدد"}
            />
            {
                showUploadLoading ?
                    <div className={`loadingContainer ${css`width: 100%;`}`}>
                        <div className={css`
                          display: grid;
                          gap: .75rem;`
                        }>
                            <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری تصویر جدید، لطفا صبور باشید...</span>
                            <LinearProgress
                                hidden={false}
                                variant="buffer"
                                value={uploadPercent}
                                valueBuffer={0}
                            />
                        </div>

                    </div> : ""
            }

            {/*{
                showUploadLoading ?
                    <div className={`loadingContainer ${css`width: 100%;`}`}>
                        <div className={css`
                          display: grid;
                          gap: .75rem;`
                        }>
                            <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری تصویر جدید، لطفا صبور باشید...</span>
                            <LinearProgress
                                hidden={false}
                                variant="buffer"
                                value={uploadPercent}
                                valueBuffer={0}
                            />
                        </div>

                    </div> : ""
            }

            <input
                ref={uploadPhotoFile}
                type="file"
                hidden
                accept="image/png,image/gif,image/jpeg"
                onChange={uploadImageFile}/>*/}

            {/*<RaikoFlexAlignEnd className={css`gap: .5rem`}>
                {
                    imageFile &&
                    <RaikoButtonSecondary
                        label={"انتخاب تصویر"}
                        onClick={handleSelectImageFile}
                    />
                }
                {
                    imageFile &&
                    <RaikoButtonPrimary
                        label={"بارگزاری تصویر"}
                        onClick={handleUploadImage}
                    />
                }
                {
                    !imageFile &&
                    <RaikoButtonPrimary
                        label={"انتخاب تصویر"}
                        onClick={handleSelectImageFile}
                    />
                }
            </RaikoFlexAlignEnd>*/}
        </div>
    )
}
